// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__5Fx0h","choiceBoxes":"toolbarselects_choiceBoxes__1PWMr","simpleField":"toolbarselects_simpleField__2whs4"};